// extracted by mini-css-extract-plugin
export var bannerContent = "downloadAppBanner-module--banner-content--af0f1";
export var bannerText = "downloadAppBanner-module--banner-text--22be0";
export var downloadAppBanner = "downloadAppBanner-module--download-app-banner--a21e7";
export var hide = "downloadAppBanner-module--hide--88dbe";
export var icon = "downloadAppBanner-module--icon--69900";